import React from 'react';

import Button from '@atlaskit/button';

const ButtonDisabledExample = (): React.JSX.Element => {
	return (
		<Button appearance="primary" isDisabled>
			Disabled button
		</Button>
	);
};

export default ButtonDisabledExample;
